import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

export type ReceivingMode = 'DATES' | 'DELIVERY' | null;

export type ReceivingState = {
  checked: boolean;
  selectedTab: number;
  startDate: MaterialUiPickersDate | null;
  endDate: MaterialUiPickersDate | null;
  deliveryNumber: string;
  mode: ReceivingMode;
  isErrorVisible: boolean;
};

export type ReceivingActions = {
  setSelectedTab: (v: number) => void;
  setStartDate: (d: MaterialUiPickersDate | null) => void;
  setEndDate: (d: MaterialUiPickersDate | null) => void;
  setDeliveryNumber: (v: string) => void;
  setMode: (m: ReceivingMode) => void;
  setIsErrorVisible: (v: boolean) => void;
  handleSelectDelivery: (
    e: React.MouseEvent,
    codeDelivery: string,
    index: number
  ) => void;
  resetToInitialDates: () => void;
};

export enum ReceivingStatus {
  NEW = 'New',
  IN_USE = 'In Use',
  PARTIAL = 'Partial',
  CONFIRMED = 'Confirmed',
}
